import React from "react";

import TourPage from "../TourPage";
import TourModal from "components/shared/Tour/TourModal/TourModal";

class AhmaTourModal extends TourModal {
  renderTourPage() {
    return (
      /* Custom: Custom TourPage with custom TourSlider */
      <TourPage
        projectId={this.props.projectId}
        redirectUrl={this.props.redirectUrl}
        completedTour={this.props.completedTour}
        slidesLength={this.props.slidesLength}
        setSlidesLength={this.props.setSlidesLength}
        setCompletedTour={this.props.setCompletedTour}
        handleCloseClick={this.props.handleCloseClick}
        language={this.props.language}
      />
    );
  }
}

export default AhmaTourModal;
